var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "48px",
    viewBox: "0 0 72 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Tender_AmEx") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0008 0 72 0 72 47.9996 0.0008 47.9996"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tender_AmEx",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0008,35.5716 L72.0008,23.9996 L72.0008,12.4276 L72.0008,3.9456 C72.0008,1.7676 70.2328,-0.0004 68.0528,-0.0004 L51.1788,-0.0004 L39.1788,-0.0004 L3.9468,-0.0004 C1.7668,-0.0004 0.0008,1.7676 0.0008,3.9456 L0.0008,12.4856 L0.0008,23.9996 L0.0008,35.5156 L0.0008,44.0536 C0.0008,46.2336 1.7668,47.9996 3.9468,47.9996 L38.8968,47.9996 L50.8968,47.9996 L68.0528,47.9996 C70.2328,47.9996 72.0008,46.2336 72.0008,44.0536 L72.0008,35.5716 Z",
    id: "Fill-1",
    fill: "#48A0DC",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#48A0DC",
    points: "38.1532 17.7298 38.1532 30.2498 35.1072 30.2498 35.1072 20.4558 30.7632 30.2498 28.1292 30.2498 23.7852 20.4558 23.7852 30.2498 17.6892 30.2498 16.5312 27.4778 10.2952 27.4778 9.1412 30.2498 5.9072 30.2498 11.2672 17.7298 15.7012 17.7298 20.7812 29.6038 20.7812 17.7298 25.6812 17.7298 29.6092 26.2298 33.1652 17.7298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6336,15.2678 L38.1536,15.2678 L33.1656,15.2678 L31.5136,15.2678 L30.8756,16.7718 L29.4956,20.0738 L27.9316,16.6898 L27.2656,15.2678 L25.6796,15.2678 L20.7816,15.2678 L18.3036,15.2678 L18.3036,17.5038 L17.9816,16.7538 L17.3396,15.2678 L15.7016,15.2678 L11.2656,15.2678 L9.6296,15.2678 L8.9876,16.7538 L3.6276,29.2738 L2.1496,32.7298 L5.9076,32.7298 L9.1416,32.7298 L10.7936,32.7298 L11.4296,31.2038 L11.9496,29.9598 L14.8796,29.9598 L15.3996,31.2038 L16.0356,32.7298 L17.6876,32.7298 L23.7856,32.7298 L26.2656,32.7298 L26.2656,32.1678 L26.5156,32.7298 L28.1296,32.7298 L30.7616,32.7298 L32.3756,32.7298 L32.6256,32.1658 L32.6256,32.7298 L35.1056,32.7298 L38.1536,32.7298 L40.6336,32.7298 L40.6336,30.2498 L40.6336,17.7298 L40.6336,15.2678 Z M38.1536,17.7298 L38.1536,30.2498 L35.1056,30.2498 L35.1056,20.4558 L30.7616,30.2498 L28.1296,30.2498 L23.7856,20.4558 L23.7856,30.2498 L17.6876,30.2498 L16.5316,27.4778 L10.2956,27.4778 L9.1416,30.2498 L5.9076,30.2498 L11.2656,17.7298 L15.7016,17.7298 L20.7816,29.6038 L20.7816,17.7298 L25.6796,17.7298 L29.6076,26.2298 L33.1656,17.7298 L38.1536,17.7298 Z",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    points: "11.3582 24.8908 15.4702 24.8908 13.3922 19.9008"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#000000",
    points: "50.3972 27.6624 50.3972 30.2504 40.3712 30.2504 40.3712 17.7304 50.3972 17.7304 50.3972 20.3644 43.3732 20.3644 43.3732 22.6264 50.2112 22.6264 50.2112 25.1684 43.3732 25.1684 43.3732 27.6624"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    points: "60.8934 23.844 69.8514 15.268 59.0394 15.268 56.5454 17.948 54.2354 15.268 38.1114 15.268 38.1114 32.732 53.9594 32.732 56.4994 30.006 58.9014 32.732 68.6494 32.732"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#48A0DC",
    points: "63.6434 30.3684 60.2894 30.3684 56.5934 26.2084 52.7594 30.3684 40.9334 30.3684 40.9334 17.8484 52.9434 17.8484 56.6394 21.9584 60.4274 17.8484 63.6434 17.8484 57.8934 24.0884"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#FFFFFF",
    points: "51.1394 27.6506 54.5594 24.0006 51.3254 20.3506 43.7954 20.3506 43.7954 22.6146 50.3534 22.6146 50.3534 25.1546 43.7954 25.1546 43.7954 27.6506"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "assets/media/amex.a6ca0ec0faf522f9a006fb82fe23f265.svg";
export { ForwardRef as ReactComponent };